import { AbstractControl, ValidationErrors } from '@angular/forms';
import dayjs from 'dayjs';
import { LdEventRepairStatus } from '@app/main/leak-detection/enums/ld-event-repair-status.enum';

export function isRepairDateInRange(date: Date, repairStatus: LdEventRepairStatus | null): boolean {
  const day = dayjs(date);

  if (repairStatus === LdEventRepairStatus.RepairScheduled) return !day.isBefore(dayjs().startOf('day'));
  if (repairStatus === LdEventRepairStatus.Repaired) return !day.isAfter(dayjs().endOf('day'));

  return true;
}

export function dialogEventRepairDateValidator(control: AbstractControl): ValidationErrors | null {
  const value: unknown = control.value;

  if (!value) return null;

  if (!(value instanceof Date) || isNaN(value.getTime())) return { dateFormat: true };

  const repairStatus: LdEventRepairStatus | null = control.parent?.get('repairStatus')?.value ?? null;

  if (isRepairDateInRange(value, repairStatus)) return null;

  return repairStatus === LdEventRepairStatus.RepairScheduled ? { pastDate: true } : { futureDate: true };
}
